import styles from './NavBarItem.styles.scss';
import { NavBarItemComponent, chameleonNavBarItemTemplate } from './NavBarItem';
import { withStylePrefix } from '../../common/withStylePrefix';
export const chameleonNavBarItemDefinition = {
    baseName: 'nav-bar-item',
    template: chameleonNavBarItemTemplate,
    styles: withStylePrefix(styles),
    shadowOptions: {
        delegatesFocus: true,
    },
};
export const chameleonNavBarItem = NavBarItemComponent.compose(chameleonNavBarItemDefinition);
